import styled from "styled-components";
import { Title, Card } from "../../settings/layout";
import MediaQueries from "../../settings/mediaQueries";

export const HomeHeader = styled.header`
    display: flex;

    ${MediaQueries.BIGGER_THAN_TABLET} {
        flex-direction: row;
        align-items: center;

        ${Title} {
            margin-bottom: 0px;
        }
    }
`;

export const HomeList = styled.div`
    display: flex;
    flex-direction: column;

    ${Card} {
        margin-bottom: 15px;
    }
`;
